<template>
	<p-card class="guideline-job-form">
		<div class="tw-flex tw-justify-between tw-items-center">
			<h3 class="tw-mb-2">Agrega todos los puestos de TRABAJO DE tu empresa</h3>
			<div>
				<app-tooltip-button
				text="Descargar reporte General en PDF"
				img="/static/img/icons/pdf.svg"
				@click-icon="$emit('downloadReportPDF')"
			></app-tooltip-button>
			<app-tooltip-button
				text="Descargar reporte General en EXCEL"
				img="/static/img/icons/excel.webp"
				@click-icon="$emit('downloadReportExcel', { type: 'xlsx', contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' })"
			></app-tooltip-button>
			</div>
		</div>
		<form class='job-form' @submit="addJob">
			<v-text-field
				label="Puesto de trabajo"
				solo
				hide-details
				class="input-text"
				v-model="jobName"
			></v-text-field>
			<v-btn class="custom-button" color="primary" fab type="submit" :disabled='disabledAddButton'>
				<v-icon>add</v-icon>
			</v-btn>
		</form>
		<v-layout row tw-mt-3>
			<v-flex xs12>
				<v-select
					label="Seleccione Área"
					class="select-core"
					hide-details
					multiple
					chips
					autocomplete
					:menu-props="{ contentClass: 'type-select-content' }"
					height="37"
					outline
					single-line
					:items="groups"
					item-value="id"
					item-text="name"
					v-model="referenceGroupCopied"
					@input="$emit('select-group', $event)">
						<template slot="selection" slot-scope="data">
							<v-chip
								class="tag-chip"
								close
								@input="removeItem(data.item)">
								{{ data.item.name }}
							</v-chip>
						</template>
					</v-select>
			</v-flex>
		</v-layout>
		<v-snackbar
			v-model="showMessage"
			:bottom="true"
		>
			{{ message }}
		</v-snackbar>
	</p-card>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';
import { any, propEq, isEmpty, clone } from 'ramda';

const INPUT_MAX_LENGTH = '60';

export default {
	name: 'guideline-job-form',
	components: { PCard },
	props: ['jobList', 'maxJobsList', 'addArea', 'referenceGroup', 'groups', 'disableAdd'],
	data() {
		return {
			jobName: '',
			showMessage: false,
			message: '',
			referenceGroupCopied: [],
		};
	},
	mounted() {
		const input = document.querySelector('.job-form input');
		input.setAttribute('maxLength', INPUT_MAX_LENGTH);
		// Ya no necesitamos loadData() porque los grupos vienen como prop
	},
	computed: {
		disabledAddButton() {
			return this.disableAdd || isEmpty(this.jobName) || this.jobList.length === this.maxJobsList;
		},
	},
	methods: {
		addJob(event) {
			event.preventDefault();
			if (this.itemExists(this.jobName)) {
				this.showMessageSnacker('Ya existe un puesto con ese nombre.');
				return;
			}
			this.$emit('jobAdded', this.jobName);
			this.jobName = '';
		},
		itemExists(jobName) {
			return any(propEq('name', jobName), this.jobList);
		},
		showMessageSnacker(message) {
			this.message = message;
			this.showMessage = true;
			setTimeout(() => { this.showMessage = false; }, 6000);
		},
		// Método removido - los grupos ahora vienen como prop desde el store
		removeItem(item) {
			const index = this.referenceGroupCopied.indexOf(item.id);
			if (index > -1) {
				this.referenceGroupCopied.splice(index, 1);
			}
			this.$emit('select-group', this.referenceGroupCopied);
		},
	},
	watch: {
		addArea: {
			handler(val) {
				if (val) {
					// Recargar grupos desde el store cuando se agrega una nueva área
					this.$store.dispatch('jobEvaluation/loadGroups');
				}
			},
		},
		referenceGroup: {
			handler(newVal) {
				this.referenceGroupCopied = clone(newVal);
			},
		},
	},
};
</script>

<style lang='scss' scoped>
.guideline-job-form {
	h3 {
		text-transform: uppercase;
		font-size: 12px;
		color: var(--app-color-primary);
	}
	.job-form {
		position: relative;
		.v-input {
			width: calc(100% - 50px);
		}
		.v-btn {
			position: absolute;
			top: 0;
			right: 0;
			width: 40px !important;
			border-radius: 8px !important;
			.v-icon {
				color: white !important;
				padding-top: 5px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/jobs-profile/job-form.vue